"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/bookSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BookSection3466sItem = {
    key: Key | null | undefined;
    /** Detected variants: "isax isax-additem5" | "isax isax-security-user5" | "isax isax-calendar-tick5" | "isax isax-tick-circle5" */
    className: string;
    /** Detected variants: "Select Your Service" | "Pick Your Specialist" | "Choose Date & Time" */
    h30Text: ReactNode;
    /** Detected variants: "01" | "02" | "03" | "04" */
    h40Text: ReactNode;
    /** Detected variants: "Choose from vision tests, LASIK screening, cataract evaluation, retina care & more." | "Browse available slots and book a time that fits your schedule no waiting." */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-lg-4 col-md-6 col-sm-6" */
    divClassName?: string;
    /** Detected variants: "book-item-eight" */
    div0ClassName?: string;
    /** Detected variants: "book-icon" */
    div0ClassName2?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "count" */
    h40ClassName?: string;
};
export type HomeEightBookSectionGeneratedProps = {
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BookSection3466sItem) => Partial<ComponentProps<"h3">>);
    divDiv0H40H4Props?: Partial<ComponentProps<"h4">> | ((item: BookSection3466sItem) => Partial<ComponentProps<"h4">>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    sectionDiv0Div0ClassName?: string;
    /** Default: "Simple Booking Process" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "How to Book Your" */
    sectionDiv0Div0Div0Div0H30H3Text?: ReactNode;
    /** Default: "Eye" */
    sectionDiv0Div0Div0Div0H30H3Text2?: ReactNode;
    sectionDiv0Div0Div0Div0H30H3Visible?: boolean;
    sectionDiv0Div0Div0Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Care Appointment" */
    sectionDiv0Div0Div0Div0H30Span0SpanText?: ReactNode;
    /** Default: "team" */
    sectionDiv0Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/team/team-img.jpg" */
    sectionDiv0Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div1ClassName?: string;
    bookSection3466s: BookSection3466sItem[];
    bookSection3466sItemWrapper?: (item: BookSection3466sItem, content: ReactNode) => ReactNode;
    bookSection3466sRenderer?: (defaultNode: ReactNode) => ReactNode;
    bookSection3466sH3Visible?: boolean;
    bookSection3466sH3Renderer?: (item: BookSection3466sItem, defaultNode: ReactNode) => ReactNode;
    bookSection3466sH4Visible?: boolean;
    bookSection3466sH4Renderer?: (item: BookSection3466sItem, defaultNode: ReactNode) => ReactNode;
    bookSection3466sH3Props?: Partial<ComponentProps<"h3">> | ((item: BookSection3466sItem) => Partial<ComponentProps<"h3">>);
    bookSection3466sH4Props?: Partial<ComponentProps<"h4">> | ((item: BookSection3466sItem) => Partial<ComponentProps<"h4">>);
};

const HomeEightBookSectionGenerated: FC<HomeEightBookSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0Div0DivText = "Simple Booking Process",
    sectionDiv0Div0Div0Div0H30H3Text = "How to Book Your",
    sectionDiv0Div0Div0Div0H30H3Text2 = "Eye",
    sectionDiv0Div0Div0Div0H30H3Visible,
    sectionDiv0Div0Div0Div0H30H3Renderer,
    sectionDiv0Div0Div0Div0H30H3Props,
    sectionDiv0Div0Div0Div0H30Span0SpanText = "Care Appointment",
    sectionDiv0Div0Div1ImageWithBasePath0ImageAlt = "team",
    sectionDiv0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/team/team-img.jpg",
    sectionDiv0Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1ImageWithBasePath0ImageProps,
    divDiv0H30H3Props,
    divDiv0H40H4Props,
    sectionDiv0Div0ClassName,
    sectionDiv0Div1ClassName,
    bookSection3466s,
    bookSection3466sItemWrapper,
    bookSection3466sRenderer,
    bookSection3466sH3Visible,
    bookSection3466sH3Renderer,
    bookSection3466sH4Visible,
    bookSection3466sH4Renderer,
    bookSection3466sH3Props,
    bookSection3466sH4Props,
}) => {
    return (
        <section className="book-section-eight section wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row mb-4"}>
                    <div className="col-lg-6">
                        <div className="section-header section-header-eight">
                            <div className="section-sub-title">
                                <span className="dot" />
                                {sectionDiv0Div0Div0Div0Div0DivText}
                            </div>
                            {renderNode(sectionDiv0Div0Div0Div0H30H3Visible, sectionDiv0Div0Div0Div0H30H3Renderer, (
                                <h3 className="section-title mb-0" {...(sectionDiv0Div0Div0Div0H30H3Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H30H3Text}
                                    <br />
                                    {sectionDiv0Div0Div0Div0H30H3Text2}
                                    <span className="line">{sectionDiv0Div0Div0Div0H30Span0SpanText}</span>
                                </h3>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        {renderNode(sectionDiv0Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1ImageWithBasePath0ImageAlt} className="img-fluid rounded d-lg-block d-none" {...(sectionDiv0Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                    </div>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4 justify-content-center"}>
                    {renderCollectionNode(
                        bookSection3466s,
                        (item: BookSection3466sItem) => (
                            <div className={item.divClassName ?? "col-xl-3 col-lg-4 col-md-6 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "book-item-eight"}>
                                    <div className={item.div0ClassName2 ?? "book-icon"}>
                                        <i className={item.className} />
                                    </div>
                                    {renderItemNode(bookSection3466sH3Visible, bookSection3466sH3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof bookSection3466sH3Props === "function" ? bookSection3466sH3Props(item) : (bookSection3466sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                    ))}
                                    <p>{item.p0Text}</p>
                                    {renderItemNode(bookSection3466sH4Visible, bookSection3466sH4Renderer, item, (
                                        <h4 className={item.h40ClassName ?? "count"} {...(typeof bookSection3466sH4Props === "function" ? bookSection3466sH4Props(item) : (bookSection3466sH4Props ?? {}))} {...(typeof divDiv0H40H4Props === "function" ? divDiv0H40H4Props(item) : (divDiv0H40H4Props ?? {}))}>{item.h40Text}</h4>
                                    ))}
                                </div>
                            </div>
                        ),
                        bookSection3466sItemWrapper,
                        bookSection3466sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeEightBookSectionGenerated;
